export type AppBuildEnv = "local" | "proto" | "qa" | "prod";

const VALID_ENVS: readonly AppBuildEnv[] = ["local", "proto", "qa", "prod"];

const isValidAppBuildEnv = (value: string): value is AppBuildEnv => {
  return (VALID_ENVS as readonly string[]).includes(value);
};

/**
 * Resolves the logical build env for both:
 * - **Browser**: `import.meta.env.VITE_BUILD_ENV` from Vite `define` (`vite.config.mts`).
 * - **Node / build-time** (`scripts.ts`, meta-map temp bundles): `import.meta.env` is often
 *   missing; `vite.config.mts` sets `process.env.BUILD_ENV` to the same `appEnv` before bundles run.
 */
export function getViteBuildEnv(): AppBuildEnv {
  const fromMeta = import.meta.env?.VITE_BUILD_ENV;
  if (typeof fromMeta === "string" && isValidAppBuildEnv(fromMeta)) {
    return fromMeta;
  }

  if (typeof process !== "undefined" && process.env) {
    const fromProcess = (process.env.BUILD_ENV ?? "").trim();
    if (fromProcess.length > 0 && isValidAppBuildEnv(fromProcess)) {
      return fromProcess;
    }
  }

  return "local";
}
